<template>
  <v-dialog :value="filterForm.modalType === 'importFile'" max-width="500" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
        <v-card-title class="text-sm-left font-weight-bold" style="text-align: center !important;">
          UP CONTACT VÀO CRM
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <p class="description-text">( Nếu chưa có form vui lòng download tại đây )</p>
        <v-card-actions class="px-0 group-btn--form" style="max-width: 400px !important;">
          <v-btn color="#FF9533" @click.prevent="downloadExampleForm()" height="35px">Download form</v-btn>
          <v-spacer />
          <v-btn color="#0C8218" @click="chooseFile" height="35px">Chọn file</v-btn>
          <v-spacer />
          <v-btn color="#848484" @click="hideModal" height="35px">Hủy</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { downloadFile } from '@/helpers/utils';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    filterForm: {
      default: () => ({})
    },
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
    };
  },
  methods: {
    hideModal: function() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.modalType = '';
      this.errorMessage = '';
    },
    downloadExampleForm(){
      downloadFile('https://xcdn-cf.vuihoc.vn/template-import/template_import_mau.xlsx', 'template_import_mau.xlsx');
    },
    chooseFile(){
      this.$emit('choose-file')
      this.hideModal();
    },
  }
};
</script>

<style scoped>
/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}
/deep/ .description-text{
  font-style: italic;
  font-weight: 100;
  font-size: 14px;
  line-height: 20px;
}
</style>